import { GET_USER } from './constants';

export default function getUser() {
  return {
    type: GET_USER,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/actions.js
 **/